import { useOrderContext } from 'state/order';

export const useCartButtonText = () => {
  const { numCartPreviewEntries } = useOrderContext();

  const cartButtonText = String(numCartPreviewEntries);

  return { cartButtonText };
};
